import DeathFields, { GetDeathValidationSchema } from "./deathfields";
import HousingFields, { GetHousingValidationSchema } from "./housingfields";
import ReinstituteFields, { GetReinstituteValidationSchema } from "./reinstituefields";
import DisenrolledFields, { GetDisenrollValidationSchema } from "./disenrolledfields";
import HoldTillFields, { GetHoldTillValidationSchema } from "./holdtillfields";

export const AppStatusSectionConfigs = [
    {
        key: 'isHousing',
        component: HousingFields,
        getValidationSchema: GetHousingValidationSchema,
        fieldNames: ['contactname','contactemail','contactphone','propertyaddress','propertycity','propertystate','propertyzip','housingnotes'],
        payloadName: 'housingInfo'
    },
    {
        key: 'isReinstitute',
        component: ReinstituteFields,
        getValidationSchema: GetReinstituteValidationSchema,
        fieldNames: ['reason','facility'],
        payloadName: 'reinstituteInfo'
    },
    {
        key: 'isDeath',
        component: DeathFields,
        getValidationSchema: GetDeathValidationSchema,
        fieldNames: ['deathcircumstance','deathcircumstanceother','abuseneglectexploitation','breakdownbackupsystem'],
        payloadName: 'deathInfo'
    },
    {
        key: 'isDisenroll',
        component: DisenrolledFields,
        getValidationSchema: GetDisenrollValidationSchema,
        fieldNames: ['disenrolledreason','disenrolledreasonother','disenroll365','waiversaftermfp'],
        payloadName: 'disenrollInfo'
    },
    {
        key: 'isHold',
        component: HoldTillFields,
        getValidationSchema: GetHoldTillValidationSchema,
        fieldNames: ['holdtilldate'],
        payloadName: 'holdInfo'
    }
]